import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import potImage from "../../../assets/pot.gif";
import whatsappImage from "../../../assets/whatsapp-image.svg";
import { clearUser } from "../../../redux/slices/userSlice";
import { useNavigateWithLang } from "../../../utils/navigation";

const B2CPending = () => {
  const dispatch = useDispatch();
  const navigate = useNavigateWithLang();
  const { t } = useTranslation();

  const handleSignOut = () => {
    dispatch(clearUser());
    navigate("/login");
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#017AF1] px-24 py-10 text-white">
      <div className="flex w-full flex-col items-start md:flex-row md:items-center md:justify-between">
        {/* Left Content */}
        <div className="flex flex-col items-center space-y-6">
          <h1 className="text-center text-5xl font-bold leading-tight">{t("pendingSection.title")}</h1>
          <p className="text-center text-lg font-light md:text-left">{t("pendingSection.description")}</p>

          <div className="flex flex-col items-center space-y-4">
            <a
              href="https://wa.me/962790488840"
              target="_blank"
              rel="noopener noreferrer"
              className="relative inline-flex items-center gap-3 rounded-full border border-white px-4 py-2 text-white transition duration-300 hover:scale-105"
            >
              <img src={whatsappImage} alt="HelloCode whatsapp" className="absolute left-[-30px] w-16" />
              <span className="pl-6 pr-3 text-base font-light">{t("pendingSection.chat")}</span>
            </a>

            {/* Logout Button */}
            <button
              onClick={handleSignOut}
              className="rounded-full border border-white bg-transparent px-6 py-2 text-sm font-light transition hover:bg-white hover:text-[#007BFF]"
            >
              {t("back")}
            </button>
          </div>
        </div>

        {/* Right Pot Image */}
        <div>
          <img
            src={potImage}
            alt="HelloCode Cooking Pot"
            className="h-auto w-full max-w-[90%] md:max-w-[600px] lg:max-w-[500px]"
          />
        </div>
      </div>
    </div>
  );
};

export default B2CPending;
